const DeviceInfo = {
  getUniqueId: () => Promise.resolve('web-browser-device'),
  getDeviceId: () => 'web',
  getModel: () => 'Browser',
  getModelSync: () => 'Browser',
  getSystemName: () => 'Web',
  getSystemNameSync: () => 'Web',
  getSystemVersion: () => navigator.userAgent,
  getSystemVersionSync: () => navigator.userAgent,
  isTablet: () => false,
  isTabletSync: () => false,
  getApplicationName: () => 'RPM Web',
  getApplicationNameSync: () => 'RPM Web',
  getVersion: () => Promise.resolve('1.0.0'),
  getVersionSync: () => '1.0.0',
  getBuildNumber: () => Promise.resolve('1'),
  getBuildNumberSync: () => '1',
  getBundleId: () => 'it.medicilio.rpm.web',
  getBundleIdSync: () => 'it.medicilio.rpm.web',
  hasNotch: () => false,
  hasNotchSync: () => false,
  getManufacturer: () => Promise.resolve('Web'),
  getManufacturerSync: () => 'Web',
  getDeviceType: () => 'Handset',
  getDeviceTypeSync: () => 'Handset',
  isEmulator: () => Promise.resolve(false),
  isEmulatorSync: () => false,
  getDeviceName: () => Promise.resolve('Browser'),
  getDeviceNameSync: () => 'Browser',
  getFirstInstallTime: () => Promise.resolve(0),
  getLastUpdateTime: () => Promise.resolve(0),
  getTotalMemory: () => Promise.resolve(0),
  getUsedMemory: () => Promise.resolve(0),
  getBatteryLevel: () => Promise.resolve(-1),
  isBatteryCharging: () => Promise.resolve(false),
  isPinOrFingerprintSet: () => Promise.resolve(false),
  getCarrier: () => Promise.resolve(''),
  getReadableVersion: () => '1.0.0.1',
  getReadableVersionSync: () => '1.0.0.1',
  hasGms: () => Promise.resolve(false),
  hasHms: () => Promise.resolve(false),
  getInstallReferrer: () => Promise.resolve(''),
  getAndroidId: () => Promise.resolve(''),
  getIpAddress: () => Promise.resolve(''),
  getMacAddress: () => Promise.resolve(''),
  getPhoneNumber: () => Promise.resolve(''),
  getApiLevel: () => Promise.resolve(0),
};

export default DeviceInfo;
